(() => {
  'use strict';
  if (window.OxydiseCallTracking) return;
  const destination = 'AW-11487517320/MxN8CNOxoqkbEIi11uUq';
  const originalHref = 'tel:+441223657444';
  const numberPattern = /(?:\+44\s*|0044\s*|0)1223[\s.-]*657[\s.-]*444/g;
  const links = new Map();
  let forwarding = null;
  let configured = false;
  let queued = false;
  const allowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed?.() === true &&
        privacy?.marketingAllowed?.() === true && privacy?.saleOfDataAllowed?.() === true;
    } catch (_) { return false; }
  };
  const isBusinessNumber = href => /^(?:0|44|0044)1223657444$/.test(String(href).replace(/^tel:/i, '').replace(/\D/g, ''));
  const updateAttribute = (node, name, value) => {
    if (value !== null && node.getAttribute(name) !== value) node.setAttribute(name, value);
  };
  function remember(link) {
    if (links.has(link) || !isBusinessNumber(link.getAttribute('href'))) return;
    links.set(link, {
      href: link.getAttribute('href'),
      aria: link.getAttribute('aria-label'),
      title: link.getAttribute('title'),
      texts: new Map()
    });
  }
  function refresh() {
    queued = false;
    document.querySelectorAll('a[href^="tel:"]').forEach(remember);
    const current = allowed() ? forwarding : null;
    links.forEach((original, link) => {
      if (!link.isConnected) { links.delete(link); return; }
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const text = walker.currentNode;
        numberPattern.lastIndex = 0;
        if (!original.texts.has(text) && numberPattern.test(text.nodeValue)) original.texts.set(text, text.nodeValue);
      }
      updateAttribute(link, 'href', current ? current.href : original.href);
      for (const [attribute, value] of [['aria-label', original.aria], ['title', original.title]]) {
        updateAttribute(link, attribute, current && value ? value.replace(numberPattern, current.formatted) : value);
      }
      original.texts.forEach((value, text) => {
        if (!link.contains(text)) { original.texts.delete(text); return; }
        const next = current ? value.replace(numberPattern, current.formatted) : value;
        if (text.nodeValue !== next) text.nodeValue = next;
      });
    });
  }
  function receiveNumber(formatted, mobile) {
    if (!allowed() || typeof formatted !== 'string' || typeof mobile !== 'string') return;
    const dial = mobile.replace(/[\s().-]/g, '');
    if (!/^\+?\d{7,15}$/.test(dial) || !/^[+\d\s().-]+$/.test(formatted)) return;
    forwarding = { formatted, href: 'tel:' + dial };
    refresh();
  }
  window.OxydiseCallTracking = {
    refresh,
    getHref: () => allowed() && forwarding ? forwarding.href : originalHref
  };
  function syncConsent() {
    if (!allowed()) { forwarding = null; refresh(); return; }
    if (!configured && typeof window.gtag === 'function') {
      configured = true;
      window.gtag('config', destination, {
        phone_conversion_number: '01223 657444',
        phone_conversion_callback: receiveNumber,
        send_page_view: false
      });
    }
    refresh();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(refresh);
  }
  refresh();
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href']
  });
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('oxydise:consent-updated', syncConsent);
  document.addEventListener('consentTrackingApiLoaded', syncConsent);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', syncConsent);
  window.addEventListener('focus', syncConsent);
  syncConsent();
})();
